export enum ClientErrorReportLevel {
    CRITICAL = 'critical',
    ERROR = 'error',
    WARNING = 'warning',
}
